/* eslint-disable no-param-reassign,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-expressions */

import { EVENTS } from '../../../app/constants/events';

xplenty.controller('app.controller', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$sce',
  '$translate',
  '$location',
  'Account',
  'User',
  'Region',
  'modalService',

  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $sce,
    $translate,
    $location,
    Account,
    User,
    Region,
    modalService,
  ) {
    const redirectToLaunchpad = function (state) {
      if (state.name === 'app') {
        $state.go('app.launchpad');
      }
    };

    redirectToLaunchpad($state.current);

    $scope.$on('$stateChangeStart', function (event, newState) {
      redirectToLaunchpad(newState);
    });

    $scope.$on('$stateChangeSuccess', function (event, newState) {
      redirectToLaunchpad(newState);
    });

    $scope.$on(EVENTS.SHORTCUTS_DISPLAY_LIST, function (event, shortcuts) {
      const $tempScope = $rootScope.$new();

      $tempScope.shortcuts = shortcuts;

      $translate([
        'app.controller.modals.shortcuts.actions.title',
        'app.controller.modals.shortcuts.actions.close',
      ]).then(function (t) {
        const modalSettings = {
          titleText: t['app.controller.modals.shortcuts.actions.title'],
          closeButtonText: t['app.controller.modals.shortcuts.actions.close'],
          saveButtonHidden: true,
          thin: true,
          hasPadding: false,
          hasFooter: false,
        };
        modalService.showModal(modalSettings, '<shortcuts-list ng-model="shortcuts">', $tempScope);
      });
    });

    $scope.$on(EVENTS.SHORTCUTS_NAVIGATE, function (event, state) {
      if (typeof state === 'string') {
        $state.go(state);
      }
    });

    $rootScope.getAbsoluteUrl = function (icon) {
      return $location.absUrl() + icon;
    };
  },
]);
